(() => {
  'use strict';

  const initialise = () => {
    if (!document.body.classList.contains('template-index')) return;

    const initialiseScrollScenes = () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      const scenes = [
        ['.template-index .slideshow', '.template-index .slideshow > div', 'hero'],
        ['[data-section-type="vireo-shop-the-look"]', '.vireo-shop-the-look__shell', 'look'],
        ['[data-section-type="vireo-edelsteine-entry"]', '.ve-entry__shell', 'edelsteine']
      ].map(([sectionSelector, shellSelector, name]) => {
        const section = document.querySelector(sectionSelector);
        const shell = section?.querySelector(shellSelector);
        if (!section || !shell) return null;

        section.classList.add('vireo-scroll-scene', `vireo-scroll-scene--${name}`);
        shell.classList.add('vireo-scroll-scene__sticky');
        return { section, shell };
      }).filter(Boolean);

      if (!scenes.length) return;

      let ticking = false;
      const updateScenes = () => {
        const viewport = window.innerHeight || 1;
        const compact = window.matchMedia('(max-width: 749px)').matches;
        const shift = compact ? 18 : 26;
        const startingScale = compact ? 1.07 : 1.045;
        scenes.forEach(({ section }) => {
          const rect = section.getBoundingClientRect();
          const travel = Math.max(section.offsetHeight - viewport, 1);
          const progress = Math.max(0, Math.min(1, -rect.top / travel));
          section.style.setProperty('--vireo-scene-shift', `${Math.round(progress * -shift)}px`);
          /* The following scene covers the former one. Keep the former scene
             present instead of fading it away before the physical overlap. */
          section.style.setProperty('--vireo-scene-opacity', '1');
          section.style.setProperty('--vireo-scene-media-scale', `${(startingScale - progress * (startingScale - 1)).toFixed(3)}`);
        });
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateScenes);
      };

      updateScenes();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
    };

    const revealGroups = [
      {
        root: '.slideshow',
        items: [
          ['.hero__content', 'hero-content']
        ]
      },
      {
        root: '[data-section-type="product-grid"]',
        items: [
          ['.grid-container', 'chapter'],
          ['.grid__heading-holder', 'content'],
          ['.product-item', 'card']
        ]
      },
      {
        root: '[data-section-type="custom-content"]',
        items: [
          ['.brick__section', 'chapter'],
          ['.brick__block', 'media']
        ]
      },
      {
        root: '[data-section-type="columns"]',
        items: [
          [':scope > div', 'chapter'],
          ['.grid__heading-holder', 'content'],
          ['.grid-item', 'card']
        ]
      },
      {
        root: '[data-section-type="collections-hover"]',
        items: [
          ['collections-hover', 'chapter']
        ]
      }
    ];

    const targets = [];
    const seen = new Set();

    revealGroups.forEach((group) => {
      const section = document.querySelector(group.root);
      if (!section) return;

      let order = 0;
      group.items.forEach(([selector, type]) => {
        section.querySelectorAll(selector).forEach((element) => {
          if (seen.has(element)) return;
          seen.add(element);
          element.classList.add('vireo-reveal', `vireo-reveal--${type}`);
          element.style.setProperty('--vireo-reveal-delay', `${Math.min(order * 140, 560)}ms`);
          targets.push(element);
          order += 1;
        });
      });
    });

    initialiseScrollScenes();

    if (!targets.length) return;

    const show = (element) => element.classList.add('is-visible');
    const reset = (element) => element.classList.remove('is-visible');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(show);
      return;
    }

    document.documentElement.classList.add('vireo-motion-ready');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          show(entry.target);
          return;
        }

        /* Re-arm only after the visitor scrolls back above a module. */
        if (entry.target.classList.contains('is-visible') && entry.boundingClientRect.top > window.innerHeight) {
          reset(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -4% 0px',
      threshold: 0.16
    });

    targets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
